import { Measure, Unit } from '../types'

// Language prefix (hardcoded for now)
const DEFAULT_LANG_PREFIX = '/en'

export const ROUTES = {
  // Static routes
  HOME: `${DEFAULT_LANG_PREFIX}`,
  CONTACT_US: `${DEFAULT_LANG_PREFIX}/contact-us`,
  ABOUT_US: `${DEFAULT_LANG_PREFIX}/about-us`,
  NOT_FOUND: `${DEFAULT_LANG_PREFIX}/404`,


  // Dynamic routes
  MEASURE: {
    pattern: `${DEFAULT_LANG_PREFIX}/:measure`,
    create: (measure: Measure): string => `${DEFAULT_LANG_PREFIX}/${measure.url}`
  },

  CONVERTER: {
    pattern: `${DEFAULT_LANG_PREFIX}/:measure/:fromUnit-to-:toUnit`,
    create: (measure: Measure, fromUnit: Unit, toUnit: Unit): string =>
      `${DEFAULT_LANG_PREFIX}/${measure.url}/${fromUnit.url}-to-${toUnit.url}`,
    // todo: is this needed? Parse URL parameters (useful for breadcrumbs or SEO)
    parse: (params: { measure: string, fromUnit: string, toUnit: string }) => params
  }
} as const


// todo: needed these types and function below? (StaticRouteKey, RouteKey, isStaticRoute)

// Type for static route keys
export type StaticRouteKey = keyof Omit<typeof ROUTES, 'CONVERTER'>

// Type for all route keys
export type RouteKey = keyof typeof ROUTES

// Helper to check if a route is a static route
export const isStaticRoute = (key: RouteKey): key is StaticRouteKey => {
  return typeof ROUTES[key] === 'string'
}
